import {
  Flex,
  Table,
  TableContainer,
  Tbody,
  Td,
  Text,
  Th,
  Thead,
  Tr,
  useColorModeValue,
  Box,
  Icon,
} from "@chakra-ui/react";
import { ChevronUpIcon, ChevronDownIcon } from "@chakra-ui/icons";
import React from "react";
import {
  useGlobalFilter,
  usePagination,
  useSortBy,
  useTable,
} from "react-table";
// Custom components
import Card from "components/card/Card";
import { Pagination } from "components/customs/pagination";
import { CustomNoDataFound } from "components/customs/noDataFound";
import { PrimayButton } from "components/customs/buttons";
import { CustomDatePicker } from "components/customs/datePicker";
export function LeaderboardTable(props) {
  const { columnsData, tableData, totalPages, currentPage, setCurrentPage, activeButton, setActiveButton, selectedFilter, setSelectedFilter, selectedDate, setSelectedDate } =
    props;

  const tableInstance = useTable(
    {
      columns: columnsData,
      data: tableData,
      manualPagination: true, // Use manual pagination to handle API
      pageCount: totalPages,
      state: { pageIndex: currentPage },
    },
    useGlobalFilter,
    useSortBy,
    usePagination
  );

  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    page,
    prepareRow,
    canPreviousPage,
    canNextPage,
    nextPage,
    previousPage,
  } = tableInstance;
  const textColor = useColorModeValue("navy.700", "white");
  const borderColor = useColorModeValue("gray.200", "whiteAlpha.100");

  function handleNext() {
    if (canNextPage) {
      setCurrentPage((prev) => prev + 1);
      nextPage();
    }
  }

  function handlePrevious() {
    if (!canPreviousPage) {
      setCurrentPage((prev) => prev - 1);
      previousPage();
    }
  }

  const handleSelectDate = (date) => {
    setSelectedDate(date);
  };

  return (
    <Card
      direction="column"
      w="100%"
      px="0px"
      // overflowX={{ sm: "scroll", lg: "hidden" }}
    >
      <TableContainer>
        <Box
          borderBottom="1px solid"
          borderColor="gray.200"
          pb="16px"
          mb="16px"
        >
          <Flex justify={"space-between" } align="center" px="22px">
            <Flex gap="52px">
              {/* Buttons remain for consistency, though filter is forced to daily */}
              <PrimayButton
                key="button1"
                type="button"
                label="Most Hits"
                onClick={() => setActiveButton("mostHits")}
                disabled={false}
                isLoading={false}
                width="150px"
                height="36px"
                bg={activeButton !== "mostHits" ? "#F4F4FE" : undefined}
                color={activeButton !== "mostHits" ? "#3A50AC" : undefined}
              />
              <PrimayButton
                key="button2"
                type="button"
                label="Games Played"
                onClick={() => setActiveButton("gamesPlayed")}
                disabled={false}
                isLoading={false}
                width="150px"
                height="36px"
                bg={activeButton !== "gamesPlayed" ? "#F4F4FE" : undefined}
                color={activeButton !== "gamesPlayed" ? "#3A50AC" : undefined}
              />
              <PrimayButton
                key="button3"
                type="button"
                label="Score"
                onClick={() => setActiveButton("score")}
                disabled={false}
                isLoading={false}
                width="150px"
                height="36px"
                bg={activeButton !== "score" ? "#F4F4FE" : undefined}
                color={activeButton !== "score" ? "#3A50AC" : undefined}
              />
            </Flex>

            {activeButton === "score" && (
              <Box mb="-25px">
                <CustomDatePicker
                  selectedDate={selectedDate}
                  handleSelectDate={handleSelectDate}
                  style={{ marginBottom: 0, paddingBottom: 0 }}
                />
              </Box>
            )}
          </Flex>
        </Box>
        <Table {...getTableProps()} variant="simple" color="gray.500" mb="24px">
          <Thead>
            {headerGroups.map((headerGroup, index) => (
              <Tr {...headerGroup.getHeaderGroupProps()} key={index}>
                {headerGroup.headers.map((column, index) => (
                  <Th
                    {...column.getHeaderProps(column.getSortByToggleProps())}
                    pe="10px"
                    key={index}
                    borderColor={borderColor}
                  >
                    <Flex
                      justify="space-between"
                      align="center"
                      fontSize={{ sm: "10px", lg: "12px" }}
                      color="blue.600"
                      cursor="pointer"
                    >
                      {column.render("Header")}
                      {column.canSort && (
                        <Box ml="8px">
                          {column.isSorted ? (
                            column.isSortedDesc ? (
                              <Icon as={ChevronDownIcon} w="16px" h="16px" />
                            ) : (
                              <Icon as={ChevronUpIcon} w="16px" h="16px" />
                            )
                          ) : (
                            <Flex direction="column" gap="1px">
                              <Icon as={ChevronUpIcon} w="12px" h="12px" opacity="0.3" />
                              <Icon as={ChevronDownIcon} w="12px" h="12px" opacity="0.3" />
                            </Flex>
                          )}
                        </Box>
                      )}
                    </Flex>
                  </Th>
                ))}
              </Tr>
            ))}
          </Thead>
          <Tbody {...getTableBodyProps()}>
            {page.map((row, index) => {
              prepareRow(row);
              return (
                <Tr
                  {...row.getRowProps()}
                  key={index}
                  // bg={index < 3 ? "brand.150" : "inherit"}
                >
                  {row.cells.map((cell, index) => {
                    return (
                      <Td
                        {...cell.getCellProps()}
                        key={index}
                        fontSize={{ sm: "14px" }}
                        minW={{ sm: "150px", md: "200px", lg: "auto" }}
                        borderColor="transparent"
                      >
                        <Flex align="center">
                          <Text
                            color={textColor}
                            fontSize="sm"
                            fontWeight="700"
                          >
                            {cell.value}
                          </Text>
                        </Flex>
                      </Td>
                    );
                  })}
                </Tr>
              );
            })}
          </Tbody>
        </Table>
        {totalPages === 0 ? (
          <CustomNoDataFound />
        ) : (
          <Pagination
            {...{
              currentPage,
              totalPages,
              handleNext,
              handlePrevious,
            }}
          />
        )}
      </TableContainer>
    </Card>
  );
}
